import { fetcher } from '../utils'

export default async (connectionKey: string, phoneNumber: string): Promise<void> =>
  fetcher(`/api/contact/block/${connectionKey}/${phoneNumber}`, 'PUT', undefined)
